// Types for the Transaction Explorer module.
// A "transaction" is a ClassName; an "execution" is a CorrelationId.
// Enum numeric values mirror the backend (Commons) enums.

export enum TransactionStatus {
  Unknown = 0,
  Success = 1,
  Failed = 2,
}

export enum TemplateDirection {
  Request = 1,
  Response = 2,
}

export interface IPagedResult<T> {
  items: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export interface ITransactionSearchFilters {
  dateFrom?: string;
  dateTo?: string;
  className?: string;
  status?: TransactionStatus;
  username?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  order?: 'Asc' | 'Desc';
}

export interface ITransactionSummary {
  className: string;
  routeLabel?: string | null;
  postLocation?: string | null;
  totalCalls: number;
  successful: number;
  failed: number;
  successRate: number; // 0..1
  lastExecutedAt?: string | null;
}

export interface IStatBucket {
  date: string;
  total: number;
  successful: number;
  failed: number;
}

export interface ITransactionStatistics {
  className: string;
  windowDays: number;
  windowFrom: string;
  windowTo: string;
  totalCalls: number;
  successful: number;
  failed: number;
  successRate: number; // 0..1
  dailyBuckets: IStatBucket[];
}

export interface ITransactionTemplate {
  id: number;
  className: string;
  direction: TemplateDirection;
  contentType?: string | null;
  templateBody?: string | null;
  occurrenceCount: number;
  sampleCorrelationId?: string | null;
  rank: number;
  generatedAt: string;
  isPinned: boolean;
  pinnedAt?: string | null;
}

export interface ICreateTransactionTemplate {
  direction: TemplateDirection;
  payload: string;
}

// A configured parameter of a ClassName (transaction route) from the AdminWeb DB.
export interface ITransactionParameter {
  id?: string;
  transactionId?: string;
  paramType: number;
  paramName: string;
  paramValue: string;
  paramValueType: number;
  isLibEditAllowed?: boolean;
  isDeleted?: boolean;
}

export interface IKeyValue {
  key: string;
  value?: string | null;
}

export interface ITransactionExecutionSummary {
  correlationId: string;
  className: string;
  status: TransactionStatus;
  startedAt: string;
  durationMs?: number | null;
  caller?: string | null;
  impersonator?: string | null;
}

export interface ITransactionExecution {
  correlationId: string;
  className: string;
  status: TransactionStatus;
  startedAt: string;
  durationMs?: number | null;
  caller?: string | null;
  impersonator?: string | null;
  parameters: IKeyValue[];
  requestBody?: string | null;
  responseBody?: string | null;
  requestContentType?: string | null;
  responseContentType?: string | null;
}
